module.exports = new __parcel__URL__("dolphin.3052ec02.svg").toString();